import React from "react";

import IcDown from "../../Svg/IcDown";
import styles from './Summary.module.css'

const CardSummary = props => {
  
  const {card, title, progressPercent, classes, compare, description, ...other} = props
  return(
    <div className={styles.card} {...other}>
      <div className="d-flex justify-content-between">
          <h3 className={styles.title}>{title}</h3>
          <span className={`${styles.progressPercent} ${progressPercent > 0 && styles.up}`}>{progressPercent}% <IcDown /></span>
      </div>
      <div className={styles.turmas}>
        <h3>{classes} turmas</h3>
        <p>{compare} em relação a Agosto</p>
      </div>
      <div className={styles.description}>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default CardSummary 